import { ISubscriptionSettingList } from 'models/subscription-setting';
import BaseService from '../base-service';
import StandardResponse from './../../models/standard-response';
import {
    ITariffList,
    IRewardList,
    IReferralList,
    IDriverPromotionDetails,
    IDriverPromotionList,
    IDriverPromotionCodeList,
} from 'models/driver-promotion';

export default class DriverPromotionService {
    getTariffList = async (data: any): Promise<StandardResponse<ITariffList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/charge-tariffs/search`,
                method: 'post',
                data,
            });
            return new StandardResponse<ITariffList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getPremiumSubscriptionList = async (data: any): Promise<StandardResponse<ISubscriptionSettingList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/premium-subscriptions/search`,
                method: 'post',
                data,
            });

            return new StandardResponse<ISubscriptionSettingList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getRewardList = async (data: any): Promise<StandardResponse<IRewardList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/promotions/rewards/search`,
                method: 'post',
                data,
            });
            return new StandardResponse<IRewardList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getReferralList = async (data: any): Promise<StandardResponse<IReferralList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/promotions/referrals/search`,
                method: 'post',
                data,
            });

            return new StandardResponse<IReferralList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getDriverPromotionDetails = async (id: number): Promise<StandardResponse<IDriverPromotionDetails>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions/${id}`,
                method: 'get',
            });

            return new StandardResponse<IDriverPromotionDetails>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updateDriverPromotionStatus = async (id: number, data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions/${id}`,
                method: 'PATCH',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    deleteDriverPromotion = async (id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions/${id}`,
                method: 'DELETE',
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updateDriverPromotion = async (id: number, data: any): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions/${id}`,
                method: 'PUT',
                data,
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    addDriverPromotion = async (data: any): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions`,
                method: 'POST',
                data,
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getDriverPromotionList = async (data: any): Promise<StandardResponse<IDriverPromotionList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverPromotionList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getPrmotionCode = async (data: any, id: number): Promise<StandardResponse<IDriverPromotionCodeList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions/${id}/codes/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverPromotionCodeList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updatePrmotionCode = async (data: any, id: number): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/driver/promotions/${id}/code`,
                method: 'PUT',
                data,
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    deletePrmotionCode = async (id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/driver/promotions/${id}/code`,
                method: 'DELETE',
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updatePromotionsTariff = async (data: any): Promise<StandardResponse<ITariffList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver/promotions/assign-tariff`,
                method: 'post',
                data,
            });
            return new StandardResponse<ITariffList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    saveOverrideTariff = async (data: {
        id: number | null;
        tariff_id: number | null;
    }): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/driver/promotions/${data.id}/assign-tariff`,
                method: 'put',
                data: { tariff_id: data.tariff_id },
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
}
